export const elementKeys = [
  'id',
  'location',
  'air_humidity',
  'air_temperature',
  'street',
  'rl',
  'rw',
  'qd',
  'material_type',
  'line',
  'latitude',
  'longitude',
  'position',
  'grit_beads',
  'grit_type',
  'SRT',
  'date',
  'application_date',
  'notification_date',
  'remarks',
  'country',
];

export const measurementKeys = [
  'id',
  'rl',
  'rw',
  'qd',
  'srt',
  'coordinates',
  'location',
  'street',
  'line',
  'date',
  'material_type',
  'serial_number',
  'database',
  'air_humidity',
  'air_temperature',
  'application_temperature',
  'application_humidity',
  'surface_application_temperature',
  'surface_application_humidity',
  'drying_time',
  'line_width',
  'direction',
  'position',
  'section',
  'marking_material',
  'grit_beads',
  'grit_type',
  'grit_mixture',
  'grit_number',
  'grip_product',
  'grip_type',
  'grip_manufacturer',
  'grip_number',
  'remarks',
  'picture',
  'user_name',
  'job',
  'manufacturer',
  'applicator',
  'marking_machine',
  'application_note',
  'subsoil_type',
  'substrate_pretreatment',
  'dry_film_thickness',
  'harder_type',
  'pearl_and_batch_mark',
  'marking_material_and_batch',
  'marking_type',
  'dtv_sv_mark',
  'snowplow_inserts',
  'roadway_width',
  'color',
  'application_date',
  'element_id',
];



// WEBPACK FOOTER //
// ./src/constants/elementProps.js